import React from "react";
import "./style.scss";

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <svg viewBox="0 0 52 52">
        <g>
          <path d="M 21.393398282201787 30.606601717798213 A 15 15 0 1 0 21.393398282201787 9.393398282201787" />
        </g>
        <g>
          <path d="M 30.606601717798213 30.606601717798213 A 15 15 0 1 1 30.60660171779821 9.393398282201785" />
        </g>
      </svg>
    </div>
  );
};
export default LoadingSpinner;
